//https://nivo.rocks/pie/
import React, { useEffect, useId, useState } from 'react'
import { Breadcrumb, Col, Form, Row, Table } from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Card from '../../../UI/Card/Card'
import CheckMark from '../../../UI/CheckMark/CheckMark'
import _ from 'lodash';
import Graybg from '../../../UI/Graybg'
import Modals from '../../../UI/Modals/Modals'
import SecBTN from '../../../UI/SecBTN'
import Select from '../../../UI/Select/Select'
import classes from './PaperMatrix.module.css'
import PieChart from '../PieChart/PieChart'
import userService from '../../../app/services/user.service'
import Loader from '../../../UI/loader/loader'
import PaperMatrixQues from './paperMatrixQues'
import { customSort, isEmpty } from '../../../utils/custom_funtions';
import { uid as ruid } from 'react-uid';

const ProcessedTable = ({ type, data }) => {
  const arr = data.filter(obj => obj.type == type)
  // remove duplicate items from the array based on some object keys   
  const uniqueObjectsArray = arr.reduce((accumulator, current) => {
    if (
      !accumulator.find(
        (item) =>
          item.sub_topic_id === current.sub_topic_id &&
          item.sub_topic_id === current.sub_topic_id &&
          item.toughness_id === current.toughness_id
      )
    ) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);
  const sortBy = ["Easy", "Medium", "Tough", "Tougher"];
  return (
    <Table bordered className={classes.table}>
      <thead>
        <tr>
          <th>Topic</th>
          <th>Sub - topic</th>
          <th>Toughness</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {customSort({ data: uniqueObjectsArray, sortBy, sortField: "toughness" }).map(val => {
          return (
            <tr>
              <td>{val.topic_name}</td>
              <td>{val.sub_topic_name}</td>
              <td>{val.toughness}</td>
              <td>{arr.filter(x => x.sub_topic_id === val.sub_topic_id && x.sub_topic_id === val.sub_topic_id && x.toughness_id === val.toughness_id).length}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

const PaperMatrix = () => {
  // const {uid,sid,pid} = useParams();
  const uniId = useId();
  const { state } = useLocation();
  const { uid, sid, pid, batch } = state;
  const [questionType, setQuestionType] = useState([]);
  const [proceedData, setProceedData] = useState([]);
  const [topicList, setTopicList] = useState([]);
  // const [listSubTopic, setListSubTopic] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [subTopicList, setSubTopicList] = useState([]);
  const [updateMatrix, setUpdateMatrix] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isBoth, setIsBoth] = useState("0");
  const [showPopUp, setShowPopUp] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [listTopic, setListTopic] = useState([]);
  const [listToughness, setListToughness] = useState([]);
  const [toughnessCount, setToughnessCount] = useState({
    tough: "0",
    tougher: "0",
    medium: "0",
    easy: "0",
  });
  const [matrixData, setMatrixData] = useState([]);
  const [customMatrixData, setCustomMatrixData] = useState([]);
  const [matrixByUidData, setMatrixByUidData] = useState([]);
  const [paperMatrixApiData, setPaperMatrixApiData] = useState({ paper_info: null, paper_matrix: [] });
  // useNavigate hook
  const navigate = useNavigate();
  //select data

  useEffect(() => {
    setLoading(true);
    // Always call getPaperMatrix ONCE on mount
    userService
      .getPaperMatrix({ uid, sid, pid })
      .then((data) => {
        if (data.data.paper_info && data.data.paper_matrix) {
          setPaperMatrixApiData({
            paper_info: data.data.paper_info,
            paper_matrix: Object.values(data.data.paper_matrix),
          });
          setMatrixData(Object.values(data.data.paper_matrix));
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
    userService
      .getMatrixByUid(pid, uid, sid)
      .then((data) => {
        setMatrixByUidData(data.data.data);
        if (data.data.data.length !== 0) {
          setLoading(false);
          setUpdateMatrix(true);
          const datas = data.data.data;
          const arr1 = new Array(datas.length);
          for (let i = 0; i < datas.length; i++) {
            const type =
              questionType[
                questionType?.findIndex(
                  (object) => object.type_id === datas[i]?.type_id
                )
              ].type;
            const section_name =
              sectionList[
                sectionList.findIndex(
                  (object) => object.section_id === datas[i]?.sec_id
                )
              ].section_name;
            const topic_name =
              topicList[
                topicList.findIndex(
                  (object) => object.topic_id === datas[i].topic_id
                )
              ]?.topic_name;
            const sub_topic_name =
              subTopicList[
                subTopicList?.findIndex(
                  (object) => object?.sub_topic_id === datas[i]?.sub_topic_id
                )
              ]?.sub_topic_name;
            const toughness =
              listToughness[
                listToughness?.findIndex(
                  (object) => object.toughness_id === datas[i]?.toughness_id
                )
              ]?.toughness;
            if (datas[i].type_id == (5 || 9 || 10)) {
              arr1[i] = {
                matrix_id: datas[i].matrix_id,
                qid: datas[i].qid,
                sub_id: datas[i].sub_id,
                paper_id: datas[i].paper_id,
                user_id: datas[i].user_id,
                qno: datas[i].qno,
                type: type,
                type_id: datas[i].type_id,
                color_code: datas[i].color_code,
                section_id: datas[i].sec_id,
                section_name: section_name,
                topic_id: datas[i].topic_id,
                topic_name: topic_name,
                sub_topic_id: datas[i].sub_topic_id,
                sub_topic_name: sub_topic_name,
                toughness_id: datas[i].toughness_id,
                toughness: toughness,
                showEl: i == 0 ? true : arr1[i - 1].showEl ? false : true,
              };
            } else {
              arr1[i] = {
                matrix_id: datas[i].matrix_id,
                qid: datas[i].qid,
                sub_id: datas[i].sub_id,
                paper_id: datas[i].paper_id,
                user_id: datas[i].user_id,
                qno: datas[i].qno,
                type: type,
                type_id: datas[i].type_id,
                color_code: datas[i].color_code,
                section_id: datas[i].sec_id,
                section_name: section_name,
                topic_id: datas[i].topic_id,
                topic_name: topic_name,
                sub_topic_id: datas[i].sub_topic_id,
                sub_topic_name: sub_topic_name,
                toughness_id: datas[i].toughness_id,
                toughness: toughness,

              };
            }

          }
          let newArr = [];
          arr1.forEach((arr, index) => {
            if (arr.type_id == (5 || 9 || 10)) {
              newArr.push({
                ...arr,
                showEl: index == 0 ? true : newArr[index - 1].showEl == true ? false : true,
              })
            } else {
              newArr.push(arr);
            }
          })

          setCustomMatrixData(newArr);
        } else {
          // Use already-fetched paperMatrixApiData for initial setup if needed
          const datas = paperMatrixApiData.paper_matrix;
          const arr1 = new Array(datas.length);
          const arr2 = [];
          const arr3 = [];
          if (!datas[0]) {
            setLoading(false);
          } else {
            for (let i = 0; i < datas.length; i++) {
              arr1[i] = {
                type: datas[i].type,
                question: datas[i].question,
              };
              let arrrr = new Array(arr1[i].question).fill({
                sub_id: sid,
                paper_id: pid,
                user_id: uid,
                qno: i + 1,
                type: datas[i].type,
                type_id: datas[i].type_id,
                section_id: datas[i].sec_id,
                section_name: datas[i].section_name,
                color_code: datas[i].color_code,
                topic_id: "",
                topic_name: "",
                sub_topic_id: "",
                sub_topic_name: "",
                toughness_id: "",
                toughness: "",
                qid: '',
              });
              arr2.push(arrrr);
            }
            for (let i = 0; i < arr2.length; i++) {
              arr3.push(...arr2[i]);
            }
            let newArr = [];
            arr3.forEach((arr, index) => {
              if (arr.type_id == (5 || 9 || 10)) {
                newArr.push({
                  ...arr,
                  showEl: index == 0 ? true : newArr[index - 1].showEl == true ? false : true,
                })
              } else {
                newArr.push(arr);
              }
            })
            setCustomMatrixData(newArr);
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    return () => {};
  }, [subTopicList, topicList, sectionList, questionType, listToughness]);
  // },[topicList]);
  useEffect(() => {
    // userService
    // .getSubTopicList()
    // .then((data) => {
    //   setListSubTopic(data.data.data);
    //   setLoading(false)
    // })
    // .catch((err) => {
    //   console.log(err);
    //   setLoading(false)
    // });
    // Commondata API
    userService
      .getCommonList()
      .then((data) => {
        setQuestionType(data.data.data.questiontype);
        setSectionList(data.data.data.section);
      })
      .catch((err) => {
        console.log(err);
      });
    // Topic API
    userService
      .getTopicList()
      .then((data) => {
        setTopicList(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // Subtopic API
    userService
      .getSubTopicList()
      .then((data) => {
        setSubTopicList(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    //Topiclist api
    userService
      .getTopicListBySid(sid)
      .then((data) => {
        setListTopic(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    //Toughness API
    userService
      .getToughness()
      .then((data) => {
        setListToughness(data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [sid]);

  const topicHandler = (topic, i, condition) => {
    const topicName = topicList.find(
      (data) => data.topic_id == topic
    ).topic_name;
    if (condition) {
      setCustomMatrixData((data) => {
        //const updatedObject = {...data[i], topic_id: topic};
        const updatedObject = {
          ...data[i],
          topic_id: topic,
          topic_name: topicName,
          sub_topic_id: '',
          sub_topic_name: '',
          pid: ''
        };
        const updatedObject2 = {
          ...data[i + 1],
          topic_id: topic,
          topic_name: topicName,
          sub_topic_id: '',
          sub_topic_name: '',
          pid: ''
        };
        return [...data.slice(0, i), updatedObject, updatedObject2, ...data.slice(i + 2)];
      });
    } else {
      setCustomMatrixData((data) => {
        //const updatedObject = {...data[i], topic_id: topic}; 
        const updatedObject = {
          ...data[i],
          topic_id: topic,
          topic_name: topicName,
          sub_topic_id: '',
          sub_topic_name: '',
          pid: ''
        };
        return [...data.slice(0, i), updatedObject, ...data.slice(i + 1)];
      });
    }

  };
  const subTopicHandler = (e, i) => {
    const subTopicName = subTopicList.find(
      (data) => data.sub_topic_id == e.target.value
    ).sub_topic_name;
    setCustomMatrixData((data) => {
      const updatedObject = {
        ...data[i],
        sub_topic_id: e.target.value,
        sub_topic_name: subTopicName,
        qid: ''
      };
      return [...data.slice(0, i), updatedObject, ...data.slice(i + 1)];
    });
  };
  const toughnessHandler = (e, i, condition) => {
    const toughnessName = listToughness.find(
      (data) => data.toughness_id == e.target.value
    ).toughness;
    if (condition) {
      setCustomMatrixData((data) => {
        const updatedObject = {
          ...data[i],
          toughness_id: e.target.value,
          toughness: toughnessName,
          qid: ''
        };
        const updatedObject2 = {
          ...data[i + 1],
          toughness_id: e.target.value,
          toughness: toughnessName,
          qid: ''
        };
        return [...data.slice(0, i), updatedObject, updatedObject2, ...data.slice(i + 2)];
      });
    } else {
      setCustomMatrixData((data) => {
        const updatedObject = {
          ...data[i],
          toughness_id: e.target.value,
          toughness: toughnessName,
          qid: ''
        };
        return [...data.slice(0, i), updatedObject, ...data.slice(i + 1)];
      });
    }

  };
  const copyHandler = (i) => {
    setCustomMatrixData((data) => {
      const updatedObject = { ...data[i], type: data[i + 1].type, type_id: data[i + 1].type_id, qid: data[i + 1].qid, section_id: data[i + 1].section_id, section_name: data[i + 1].section_name };
      return [...data.slice(0, i + 1), updatedObject, ...data.slice(i + 2)];
    });
    // setCustomMatrixData((data)=>{
    //   const updatedObject = {...data[i]};
    //     return ([...data.slice(0, i+1),
    //     updatedObject,
    //     ...data.slice(i + 1),])
    //   })
  };
  const proceedHandler = (e) => {
    e.preventDefault();
    setShowPopUp(true);
    const tough = customMatrixData.filter(
      (data) => data.toughness_id == 3
    ).length;
    const tougher = customMatrixData.filter(
      (data) => data.toughness_id == 4
    ).length;
    const medium = customMatrixData.filter(
      (data) => data.toughness_id == 2
    ).length;
    const easy = customMatrixData.filter(
      (data) => data.toughness_id == 1
    ).length;
    setToughnessCount({
      tough: tough,
      tougher: tougher,
      medium: medium,
      easy: easy,
    });
    console.log(tough, tougher, medium, easy);
    const arr1 = [];
    for (let i = 0; i < matrixData.length; i++) {
      arr1[i] = matrixData[i].type;
    }
    setProceedData([...new Set(arr1)]);
  };
  const saveMatrixData = () => {
    const body = [];
    for (let i = 0; i < customMatrixData.length; i++) {
      body[i] = {
        matrix_id: customMatrixData[i].matrix_id
          ? +customMatrixData[i].matrix_id
          : 0,
        paper_id: +customMatrixData[i].paper_id,
        qno: i + 1,
        sub_id: +customMatrixData[i].sub_id,
        sec_id: +customMatrixData[i].section_id,
        topic_id: +customMatrixData[i].topic_id,
        sub_topic_id: customMatrixData[i].sub_topic_id ? +customMatrixData[i].sub_topic_id : 1,
        type_id: +customMatrixData[i].type_id,
        toughness_id: +customMatrixData[i].toughness_id,
        display_number: +customMatrixData[i].qno,
        user_id: +customMatrixData[i].user_id,
        is_dummy_panel: 0,
      };
    }
    // console.log(body);
    if (updateMatrix) {
      userService
        .updatePaperMatrix(body)
        .then((res) => {
          console.log(res);
          // <Col md={12} sm={12}>
          //       Paper Code : <b>{pid}</b>
          //     </Col>
          //     <Col md={12} sm={12}>
          //       Format : <b>{matrixData[0].paper_format}</b>
          //     </Col>
          //     <Col md={6} sm={12}>
          //       Exam Date : <b>{matrixData[0].to_be_held_on}</b>
          //     </Col>
          //     <Col md={6} sm={12}>
          //       Questions Assigned : <b>{customMatrixData.length}</b>
          //     </Col>
          //     <Col md={6} sm={12}>
          //       Date Of Submission : <b>{matrixData[0].to_be_completed_by}</b>
          //     </Col>
          //     <Col md={6} sm={12}>
          //       Date Of Submission : <b>{matrixData[0].center}</b>
          //     </Col>
          navigate("/createPaper/paperMatrix/Questions", {
            state: {
              paper_id: pid,
              sub_id: sid,
              faculty_id: uid,
              isBoth: isBoth,
              syllabus: paperMatrixApiData.paper_info?.topic_names,
              remarks: paperMatrixApiData.paper_info?.topic_remarks,
              format: (matrixData[0] && matrixData[0].paper_format) || paperMatrixApiData.paper_info?.format,
              exam_date: (matrixData[0] && matrixData[0].to_be_held_on) || paperMatrixApiData.paper_info?.to_be_held_on,
              assigned_q: customMatrixData.length,
              date_submiossion: (matrixData[0] && matrixData[0].to_be_completed_by) || paperMatrixApiData.paper_info?.to_be_completed_by,
              center: (matrixData[0] && matrixData[0].center) || paperMatrixApiData.paper_info?.centers

            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      userService
        .createPaperMatrix(body)
        .then((res) => {
          console.log(res);
          navigate("/createPaper/paperMatrix/Questions", {
            state: {
              paper_id: pid,
              sub_id: sid,
              faculty_id: uid,
              isBoth: isBoth,
              isBoth: isBoth,
              syllabus: paperMatrixApiData.paper_info?.topic_names,
              remarks: paperMatrixApiData.paper_info?.topic_remarks,
              format: (matrixData[0] && matrixData[0].paper_format) || paperMatrixApiData.paper_info?.format,
              exam_date: (matrixData[0] && matrixData[0].to_be_held_on) || paperMatrixApiData.paper_info?.to_be_held_on,
              assigned_q: customMatrixData.length,
              date_submiossion: (matrixData[0] && matrixData[0].to_be_completed_by) || paperMatrixApiData.paper_info?.to_be_completed_by,
              center: (matrixData[0] && matrixData[0].center) || paperMatrixApiData.paper_info?.centers
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const onHideHandler = () => {
    setShowPopUp(false);
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  return (
    <div className="section">
      <button
        onClick={() => {
          console.log("proceedData", proceedData);
          console.log("customMatrixData", customMatrixData);
          console.log("matrixData", matrixData);
          console.log("matrixByUidData", matrixByUidData);
          console.log("questionType", questionType);
          console.log("updateMatrix", updateMatrix);
          console.log("subTopicList", subTopicList);
          console.log("questionType", questionType);
          console.log("topicList", topicList);
          console.log("pid", pid);
        }}
      >
        console
      </button>
      {loading && <Loader />}
      <Modals show={showPopUp} onHide={onHideHandler} size="lg">
        <h5>
          <u>Summary</u>
        </h5>
        <div style={{ height: "350px" }}>
          <PieChart
            tougher={toughnessCount.tougher}
            tough={toughnessCount.tough}
            medium={toughnessCount.medium}
            easy={toughnessCount.easy}
          />
        </div>
        {proceedData.map((data) => {
          return (
            <>
              <h6 className="mb-1">{data}</h6>
              <ProcessedTable type={data} data={customMatrixData} />
            </>
          );
        })}
        <div className="mt-3 mb-2">
          <p>Choose Language :</p>
          <Row>
            <Col md={6} sm={12}>
              <Form.Check
                type="radio"
                name="isBoth"
                label="English only"
                value="0"
                onChange={(e) => setIsBoth(e.target.value)}
                checked={isBoth === "0"}
              />
            </Col>
            <Col md={6} sm={12}>
              <Form.Check
                type="radio"
                name="isBoth"
                label="English and Hindi"
                value="1"
                onChange={(e) => setIsBoth(e.target.value)}
                checked={isBoth === "1"}
              />
            </Col>


          </Row>
        </div>
        <div className="mt-3 mb-2 text-center">
          <SecBTN className="sec-btn1" onClick={saveMatrixData}>
            Save & Proceed
          </SecBTN>
          {/* <br />
          <Link to="/createPaper/paperMatrix/Questions">next page demo</Link> */}
        </div>
      </Modals>
      <Modals show={showPopUp2} onHide={onHideHandler} size="lg">
        <h4>Paper Details</h4>
        {(paperMatrixApiData.paper_info && paperMatrixApiData.paper_matrix.length > 0) &&
          <Row className="mt-3">
            <Col md={6} sm={12}>
              <b>Paper Code:</b> {paperMatrixApiData.paper_info.paper_id}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Name:</b> {paperMatrixApiData.paper_info.paper_name}
            </Col>
            <Col md={6} sm={12}>
              <b>Batch:</b> {paperMatrixApiData.paper_info.batch_name || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Target:</b> {paperMatrixApiData.paper_info.target || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Session:</b> {paperMatrixApiData.paper_info.Session || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Center:</b> {paperMatrixApiData.paper_info.centers || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Class:</b> {paperMatrixApiData.paper_info.classes || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Requested By:</b> {paperMatrixApiData.paper_info.creator || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Requested On:</b> {paperMatrixApiData.paper_info.created_on ? new Date(paperMatrixApiData.paper_info.created_on).toLocaleString() : 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Format:</b> {paperMatrixApiData.paper_info.paper_format || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Exam On:</b> {paperMatrixApiData.paper_info.to_be_held_on || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Last Date of Submission:</b> {paperMatrixApiData.paper_info.to_be_completed_by || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Phase:</b> {paperMatrixApiData.paper_info.phase || 'NA'}
            </Col>
            <Col md={12} sm={12}>
              <div className="d-flex">
                <b>Questions Assigned :</b>
                <div>
                  {paperMatrixApiData.paper_matrix.sort((a, b) => a.sec_id - b.sec_id).map(data => {
                    return (
                      <div className="d-flex ps-1" key={ruid(data)}>
                        <b>{`${data.section_name} : `}</b>
                        <span className="ps-1">{` ${data.question}`}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        }
      </Modals>
      <Modals show={showPopUp1} onHide={onHideHandler} size="lg">
        <h4 className="mb-3">Syllabus</h4>
        <div className='d-flex gap-1'>
          <span className="text-muted">Topic Name: </span>
          <div>
            {paperMatrixApiData.paper_info?.topic_names}
          </div>
        </div>
        <div className='d-flex gap-1'>
          <span className="text-muted">Topic Remark: </span>
          <div>
          {paperMatrixApiData.paper_info?.topic_remarks}
          </div>
        </div>
      </Modals>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Paper Matrix</h4>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/createPaper">Create Paper</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Pending</Breadcrumb.Item>
            <Breadcrumb.Item active>Paper Matrix</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={classes["pm-info-btn"]}>
          <SecBTN className="sec-btn" onClick={() => setShowPopUp2(true)}>
            Paper Details
          </SecBTN>
          <SecBTN className="sec-btn" onClick={() => setShowPopUp1(true)}>
            View Syllabus
          </SecBTN>
        </div>
      </div>
      {customMatrixData.length === 0 && (
        <p className="text-center">No data available</p>
      )}
      {customMatrixData.length !== 0 && (
        <Graybg>
          <form onSubmit={proceedHandler}>
            {customMatrixData.sort((a, b) => a.section_id - b.section_id).map((data, i) => {
              return (
                <PaperMatrixQues
                  // key={ruid(data)+uniId}
                  sid={sid}
                  pid={data.paper_id}
                  color_code={data.color_code}
                  qNo={i + 1}
                  type={data.type}
                  type_id={data.type_id}
                  listSubTopic={subTopicList}
                  updateMatrix={updateMatrix}
                  matrixLength={customMatrixData.length}
                  showEl={data.showEl ?? ""}
                  validate={
                    data.type_id !==
                      (5 || 9 || 10 || 11 || 12 || 13 || 14 || 15)
                      ? data.topic_id !== "" &&
                      data.sub_topic_id !== "" &&
                      data.toughness_id !== ""
                      : data.topic_id !== "" && data.toughness_id !== ""
                  }
                  prevSec_id={
                    i !== 0
                      ? customMatrixData.sort(
                        (a, b) => a.section_id - b.section_id
                      )[i - 1].section_id
                      : 0
                  }
                  nextSec_id={
                    i !== customMatrixData.length - 1
                      ? customMatrixData.sort(
                        (a, b) => a.section_id - b.section_id
                      )[i + 1].section_id
                      : 0
                  }
                  sec_id={data.section_id}
                  sectionName={data.section_name}
                  selectedTopic={data.topic_id}
                  selectedSubTopic={data.sub_topic_id}
                  selectedToughness={data.toughness_id}
                  transferedTopic={(topic, condition = false) => topicHandler(topic, i, condition)}
                  subTopicHandler={(e) => subTopicHandler(e, i)}
                  toughnessHandler={(e, condition = false) => toughnessHandler(e, i, condition)}
                  listTopic={listTopic}
                  listToughness={listToughness}
                  copyHandler={() => copyHandler(i)}
                  qid={data.qid}
                  matrixByUidData={matrixByUidData}
                />
              );
            })}
            <div className="text-center mt-5 mb-2">
              <SecBTN className="sec-btn1" type="submit">
                Proceed
              </SecBTN>
            </div>
          </form>
        </Graybg>
      )}
    </div>
  );
}

export default PaperMatrix;
